import type {SegmentedControlOption} from '@cohort/merchants/components/form/SegmentedControl';
import {SegmentedControl} from '@cohort/merchants/components/form/SegmentedControl';
import {List, SquaresFour} from '@phosphor-icons/react';

interface CardListDisplayTogglerProps {
  display: 'card' | 'list';
  setDisplay: (display: 'card' | 'list') => void;
}

const CardListDisplayToggler: React.FC<CardListDisplayTogglerProps> = ({display, setDisplay}) => {
  const options: SegmentedControlOption[] = [
    {
      value: 'card',
      icon: <SquaresFour size={20} />,
      testId: 'card-display-toggle',
    },
    {
      value: 'list',
      icon: <List size={20} />,
      testId: 'list-display-toggle',
    },
  ];
  return (
    <SegmentedControl
      options={options}
      currentOption={options.find(opt => opt.value === display) as SegmentedControlOption}
      onChange={opt => setDisplay(opt.value as 'card' | 'list')}
    />
  );
};

export default CardListDisplayToggler;
